import { Screen } from '@/types';

import type { IAppStore } from '@/store';

export type PostGenerationDecision = { kind: 'notify' } | { kind: 'none' };

/**
 * Decides what to do after a generation completes.
 *
 * We never auto-open a result on top of the user — opening (and especially
 * switching an already-open) lightbox is disruptive. Instead every completion
 * only notifies (an aggregated "N creations ready" toast); the user opens
 * results from the Creations grid themselves.
 *
 *  - `notify`: surface the completion via the batch toast.
 *  - `none`: the user is on the legacy loading screen; the auto-generation flow
 *    handles its own transition.
 */
const decidePostGenerationUX = ({
  screen,
}: {
  screen: IAppStore['screen'];
}): PostGenerationDecision => {
  if (screen === Screen.Loading) return { kind: 'none' };
  return { kind: 'notify' };
};

export default decidePostGenerationUX;
